/**
 * Single source of truth for onboarding completion requirements that the
 * wizard's per-step validation and the backend completion contract must agree
 * on. Historically these drifted: the backend ProfileCompletionService requires
 * a contractor to have >= 3 specializations, but the wizard let contractors
 * through with just 1 — so they finished onboarding yet stayed permanently
 * below 100% completeness. Keeping the rule here stops that divergence.
 *
 * Mirrors backend ProfileCompletionService:
 *   - checkContractorProfile: specializations.length >= 3
 *   - checkVerifierProfile:   specializations.length >= 1
 */

// Minimum specializations required, per role. Roles not listed default to 1.
export const MIN_SPECIALIZATIONS = {
  contractor: 3,
};

export const minSpecializations = (role) => MIN_SPECIALIZATIONS[role] ?? 1;
